<template>
  <section class="form relative">
		<form
			id="contact-form"
			ref="form"
			method="POST"
			name="leasing"
			@submit.prevent="checkForm"
			:class="['flex', 'flex-col', 'items-start', 'mb-0', 'md:mb-32', { 'opacity-0': submitted }]"
		>
			<input type="hidden" name="form-name" value="leasing">

			<div class="input flex flex-col relative mb-6 w-full">
				<label for="subject" :class="['text-lg', 'font-body', 'text-gray-400', { active: hasValue(form.subject) }]">Subject</label>
				<input
					type="text"
					name="subject"
					class="h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2"
					v-model="form.subject"
					:data-error="errors.subject"
				>
			</div>
			
			<div class="input flex flex-col relative mb-6 w-full">
				<label for="name" :class="['text-lg', 'font-body', 'text-gray-400', { active: hasValue(form.name) }]">Name</label>
				<input
					type="text"
					name="name"
					class="h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2"
					v-model="form.name"
					:data-error="errors.name"
				>
			</div>

			<div class="input flex flex-col relative mb-6 w-full">
				<label for="email" :class="['text-lg', 'font-body', 'text-gray-400', { active: hasValue(form.email) }]">E-mail</label>
				<input
					type="email"
					name="email"
					class="h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2"
					v-model="form.email"
					:data-error="errors.email"
				>
			</div>

			<div class="input flex flex-col relative mb-6 w-full">
				<label for="phone" :class="['text-lg', 'font-body', 'text-gray-400', { active: hasValue(form.phone) }]">Phone</label>
				<input
					type="tel"
					name="phone"
					class="h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2"
					v-model="form.phone"
				>
			</div>

			<div class="input flex flex-col relative mb-18 md:mb-16 w-full">
				<label for="comments" class="text-lg font-body" :class="['text-lg', 'font-body', 'text-gray-400', { active: hasValue(form.comments) }]">Comments</label>
				<textarea
					name="comments"
					class="font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2 h-28"
					v-model="form.comments"
					:data-error="errors.comments"
				></textarea>
			</div>

			<button
				type="submit"
				:disabled="!valid"
				class="text-white px-8 py-4 text-lg leading-6 font-body"
				:class="[valid ? 'bg-gray-800' : 'bg-gray-300']"
			>Submit</button>
		</form>

		<div class="success center absolute top-0 left-0" v-show="submitted">
			<h3>The form has been submitted.</h3>
		</div>
  </section>
</template>

<script>
import axios from "axios";
import { stringify } from 'qs';

const axiosInstance = axios.create({
	headers: {
		'X-CSRF-Token': window.csrfToken,
		'X-Requested-With': 'XMLHttpRequest',
		'Accept': 'application/json'
	},
	transformRequest: [
		(data) => {
			return stringify(data);
		},
	],
});

export default {
  name: 'leasingForm',
	data() {
		return {
			errors: {
        subject: null,
        name: null,
				email: null
      },
			submitted: false,
			focused: '',
			form: {
				subject: '',
				name: '',
				phone: '',
				comments: '',
				email: '',
			},
		};
	},
	computed: {
		valid () {
			return this.form.subject.length && this.form.name.length && this.form.email.length;
		}
	},
	methods: {
		resetErrors() {
			this.errors = {
				subject: null,
        name: null,
				email: null
			};
		},
		checkForm(e) {
			let form = this.form;

			if (form.subject && form.name && form.email) {
				this.send();
			}

			this.resetErrors();

			if (!form.subject) {
				this.errors.subject = true;
			}

			if (!form.name) {
				this.errors.name = true;
			}

			if (!form.email) {
				this.errors.email = true;
			}
		},
		hasValue(e) {
			return e.length > 0
		},
		send() {
			const formData = {
				action: 'contact-form/send',
				fromName: this.form.name,
				fromEmail: this.form.email,
				message: {
					Subject: this.form.subject,
					Phone: this.form.phone,
					Comments: this.form.comments
				}
			};

			axiosInstance.post('/', formData).then((res) => {
				console.log(res);
				this.submitted = true;
			})
			.catch((err) => {
				console.log(err);
			});
		}
	},
	watch: {
		form (newValue, oldValue) {

			console.log('newValue', newValue);
		}
	}
};
</script>
